import type { PlayerPropWithGradeAnalysis } from '@pff-consumer/schema'

export const transformPlayerPropBetsResponse = (
  playerPropBets: PlayerPropWithGradeAnalysis[]
): PlayerPropWithGradeAnalysis[] => {
  return playerPropBets.map((pb) => {
    return { ...pb, eventId: pb.eventId || pb.gameId }
  })
}
